import { createFileRoute } from '@tanstack/react-router'

import { OrgScreen } from '@/features/platform-orgs/org-screen'

/** One org in the console, reached from its row on Organisations or from adding it. */
export const Route = createFileRoute('/_app/platform/organisations/$orgId')({
  component: function OrgRoute() {
    const { orgId } = Route.useParams()
    return <OrgScreen key={orgId} orgId={orgId} />
  },
})
